import { localizePath, stripLocalePrefix } from "./localeRoutes";

export function getResourceLinks(locale: string) {
  return {
    hub: localizePath("/resources", locale),
    patients: localizePath("/articles", locale),
    doctors: `${localizePath("/articles", locale)}?audience=doctor`,
    insurance: `${localizePath("/articles", locale)}?audience=insurance`,
    tools: localizePath("/free-tools", locale),
    pharmacy: localizePath("/pharmacy-finder", locale),
  };
}

export function isResourcePath(pathname: string): boolean {
  const path = stripLocalePrefix(pathname).replace(/\/$/, "");
  return (
    path === "/resources" ||
    path === "/free-tools" ||
    path === "/articles" ||
    path.startsWith("/articles/") ||
    path === "/pharmacy-finder"
  );
}
